module.exports = __webpack_public_path__ + "static/media/ice-cream-how-it-works.6786dd1e.png";